// import Mustache from 'mustache';
import Mustache from 'mustache';
import React, { useEffect, useState } from 'react';
import { Bell, Calendar2, Calendar2Range, CalendarPlus, Check2Circle, Clipboard2, Clipboard2Plus, ClockHistory, LockFill, PersonAdd, PersonCheck, Trash2 } from 'react-bootstrap-icons';
import { BiMessage } from 'react-icons/bi';
import { RiDashboard2Line } from 'react-icons/ri';
import Calendars from '../../../../../../libs/api/services/Calendars';
import MessageTemple from '../../../../../../libs/api/services/MessageTemple';
import Questionnaire from '../../../../../../libs/api/services/Questionnaire';
import { FormPreview, MessageTemplatePreview, NotificationPreview } from './Triggers/Types/BasicTableTaskPropertiesComponent';
export default function BreakdownLineItem({ workflow }) {
    // const view = {
    //     "test|name": 'test survey',
    //     title: "Joe",
    //     calc: () => (2 + 4)
    // };
    // console.log('must 123', Mustache.render(`
    //     Questionnaire / Form / Survey {{#test|name}} {{{.}}} {{/test|name}}  {{^test|name}} no survey {{/test|name}} Has Started`, view))
    return (
        <div className="bg-light text-dark">
            {
                !workflow.triggers || workflow.triggers.length === 0 ? <div>This workflow will never run due to there being nothing to trigger it</div> :
                    <div>
                        <b>When any of the following events happen</b>
                        {workflow.triggers.map(t => <WFTriggerEventsBD trigger={t} />)}
                    </div>
            }
            <b>The system will</b>
            {
                !workflow.triggers || workflow.triggers.length === 0 ? <div>Do nothing because there are no tasks assigned to it</div> :
                    workflow.tasks.map(t => <WFTaskBD task={t} />)
            }
            <pre>
                {/* {JSON.stringify(workflow.tasks, '\t', 2)} */}
            </pre>
        </div>
    )
}

//questionnaire_started|type
const TRIGGER_CONFIG = {
    "QUESIONNAIRE_STARTED": {
        icon: <Clipboard2 size={30} />,
        readableText: '{{#questionnaire_started|name}}{{{.}}} {{questionnaire_started|type}} has been started{{/questionnaire_started|name}}{{^questionnaire_started|name}}No questionnaire has been set to trigger once started{{/questionnaire_started|name}}',
        requires: {
            "questionnaire_started.name": "Will NOT trigger because Questionnaire / Form / Survey has no questionnaire set",
        }
    },
    /*{
  "message_filter_options|messageTypes": "WhatsApp",
  "message_filter_options|receivedFrom": [
    "0",
    "1"
  ],
  "message_filter_options|subject": "test"
}*/
    /*{{#.}}
                    {{{.}}}{{^last}},{{/last}}
                {{/.}}*/
    "MESSAGE_RECEIVED": {
        icon: <BiMessage size={30} />,
        readableText: `
        {{#message_filter_options|receivedFrom}}
            Messages from 
            {{{.}}}
        {{/message_filter_options|receivedFrom}} 
        {{^message_filter_options|receivedFrom}}
            All messages
        {{/message_filter_options|receivedFrom}} 
        {{#message_filter_options|subject}}
            with subject {{{.}}} 
        {{/message_filter_options|subject}}
        {{^message_filter_options|subject}}
            with any subject 
        {{/message_filter_options|subject}}
        have been received by the system
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*
    {
  "dashboard_card|dashboard": "CLINICIAN_PATIENT_DASHBOARD",
  "dashboard_card|dashboardCardTitle": "Tests",
  "dashboard_card|dashboardLinkDescription": "Send Test WA",
  "dashboard_card|dashboardColour": "#31B15C"
}*/
    "DASHBOARD_CARD": {
        icon: <RiDashboard2Line size={30} />,
        readableText: `
        Item {{dashboard_card|dashboardLinkDescription}} under {{dashboard_card|dashboardCardTitle}} on the {{dashboard_card|dashboard}} was selected
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "categories|id": "407ff8c2-679a-40be-a2b9-36c7c4cdf99e",
  "categories|groupNme": "Patient Profile",
  "categories|deleted": false,
  "categories|order": 0
}*/
    "PATIENT_PROFILE_QUICK_TASK": {
        icon: <PersonCheck size={30} />,
        readableText: `
        Quick task for {{categories|groupNme}} was selected while managing a patients profile
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
      "calendar_event_triggered|events|id": "862f0930-1679-4dac-40c6-08dca0c1a7c2",
      "calendar_event_triggered|events|eventName": ""
    }*/
    "CALENDAR_EVENT_EVENT": {
        icon: <Calendar2 size={30} />,
        readableText: `
        Calendar event {{calendar_event_triggered|events|eventName}} was triggered
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "cron|facility": "1",
  "cron|yearOccourance": "Every Year",
  "cron|monthOccourance": "Every Month",
  "cron|dayOccourance": "Specific Day",
  "cron|dayType": "Day of month",
  "cron|dayWhen": "1",
  "cron|hourOccourance": "Specific Hour",
  "cron|hourWhen": "1",
  "cron|minuteOccourance": "Specific Minute",
  "cron|minuteWhen": "1"
}

    */
    "CRON": {
        icon: <ClockHistory size={30} />,
        readableText: `
        A scheduled time of for facility {{cron|facility}} 
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "calendar_created|calendars|id": "1e1e3a74-5fed-4166-9c29-79266f298e60",
  "calendar_created|calendars|type": "ADMIN_PATIENT",
  "calendar_created|calendars|description": "Administrator's patient management calendar",
  "calendar_created|status|from": "",
  "calendar_created|status|to": ""
}*/
    "CALENDAR_EVENT_DATE_CHANGE": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        Date change on a calendar
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "calendar_cron|events|id": "862f0930-1679-4dac-40c6-08dca0c1a7c2",
  "calendar_cron|events|eventName": "test",
  "calendar_cron|events|properties|id": "3c6b4673-a327-4d25-f90a-08dca0c1b341",
  "calendar_cron|events|properties|name": "DEFAULT_DETAILS_ORIGINAL",
  "calendar_cron|events|properties|value": "test",
  "calendar_cron|events|whenTriggered|id": "4ad07215-99be-4ae2-ba69-0454270582b4",
  "calendar_cron|events|whenTriggered|trigger": "CREATE_CALENDAR_EVENT",
  "calendar_cron|events|whenTriggered|description": "Create an event on a calendar",
  "calendar_cron|audience": "Clinician",
  "calendar_cron|type": "Minutes",
  "calendar_cron|value": "30",
  "calendar_cron|when": "before"
}
    */
    "CALENDAR_EVENT_CRON": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        Time based event happened on a calenedar event
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "to_do_list_completed|whichList": "A Specific List",
  "to_do_list_completed|listDetails|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
  "to_do_list_completed|listDetails|list": "6a03b434-b99e-4866-3569-08dca276a86a"
}*/
    "TODO_LIST_COMPLETED_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_COMPLETED_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
      "to_do_list_re_assigned|listDetails|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
      "to_do_list_re_assigned|listDetails|item": "6eb1250c-88d8-46d4-57ca-08dca276abe7",
      "to_do_list_re_assigned|listDetails|list": "6a03b434-b99e-4866-3569-08dca276a86a"
    }*/
    "TODO_LIST_REASSIGNED_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_ reassigned
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "to_do_list_incomplete_for_x|listDetails|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
  "to_do_list_incomplete_for_x|listDetails|item": "6eb1250c-88d8-46d4-57ca-08dca276abe7",
  "to_do_list_incomplete_for_x|listDetails|list": "6a03b434-b99e-4866-3569-08dca276a86a",
  "to_do_list_incomplete_for_x|todo_timelapsed_mins": "1",
  "to_do_list_incomplete_for_x|todo_timelapsed_hours": "2",
  "to_do_list_incomplete_for_x|todo_timelapsed_days": "3"
}
    */
    "TODO_LIST_INCOMPLETE_FOR_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_INCOMPLETE_FOR_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },

    "TODO_LIST_CREATED_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_CREATED_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "to_do_list_started|listDetails|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
  "to_do_list_started|listDetails|list": "6a03b434-b99e-4866-3569-08dca276a86a"
}
    */
    "TODO_LIST_STARTED_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_STARTED_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
      "to_do_list_status_changed|listDetails|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
      "to_do_list_status_changed|listDetails|item": "1e2004d8-ce58-441a-57c9-08dca276abe7",
      "to_do_list_status_changed|listDetails|list": "6a03b434-b99e-4866-3569-08dca276a86a",
      "to_do_list_status_changed|listDetailsChange|group": "6e826f17-8c6d-47a6-2a2b-08dca276a716",
      "to_do_list_status_changed|listDetailsChange|list": "6a03b434-b99e-4866-3569-08dca276a86a",
      "to_do_list_status_changed|listDetailsChange|item": "6eb1250c-88d8-46d4-57ca-08dca276abe7"
    }
    */
    "TODO_LIST_STATUS_CHANGE_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_STATUS_CHANGE_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "calendar_status_change|calendars|id": "bfdfb66e-4d59-4c2e-a795-5f1194908bcb",
  "calendar_status_change|calendars|type": "ADMIN_CLINICIAN",
  "calendar_status_change|calendars|description": "Administrator's clinician management calendar",
  "calendar_status_change|status|from": "TENTATIVE",
  "calendar_status_change|status|to": "CONFIRMED"
}
    */
    "CALENDAR_EVENT_STATUS_CHANGE": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        CALENDAR_EVENT_STATUS_CHANGE
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*{
  "to_do_list_requested_assistance|whichList": "All Lists"
}
    */
    "TODO_LIST_ASISTANCE_REQUESTED_TRIGGER": {
        icon: <Calendar2Range size={30} />,
        readableText: `
        TODO_LIST_ASISTANCE_REQUESTED_TRIGGER
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    /*    {
  "calendar_created|calendars|id": "6a31a597-4b20-4fc4-b211-b1ea46e3d52f",
  "calendar_created|calendars|type": "CLINICIAN",
  "calendar_created|calendars|description": "Clinicians calendar",
  "calendar_created|status|from": "",
  "calendar_created|status|to": ""
}*/
    "CALENDAR_EVENT_CREATE": {
        icon: <Calendar2 size={30} />,
        readableText: `Create event {{calendar_created|calendars|id}} on {{calendar_created|calendars|description}}`,
        extra: ['Calendar Created']
    }
}
const TASK_CONFIG = {
    "Messaging": {
        icon: <BiMessage size={30} />,
        readableText: `
        {{#Message Template|audience|audienceType|type}}
        Send message template {{Message Template|name}}
        {{#Message Template|serviceType|type}} via {{{.}}}{{/Message Template|serviceType|type}}
        {{#Message Template|subject}} with subject {{{.}}}{{/Message Template|subject}}
        {{#Message Template|audience|audienceType|type}} to {{{.}}}{{/Message Template|audience|audienceType|type}}
        {{/Message Template|audience|audienceType|type}}
        {{^Message Template|audience|audienceType|type}}
        Not send out message template because there is no audience specified
        {{/Message Template|audience|audienceType|type}}
        `.replace(/\t|\n\s*|\r|\t/g, ""),
        extra: ['Message Template']
    },
    "Send Questionnaire": {
        icon: <Clipboard2 size={30} />,
        readableText: `
        {{#Questionnaire|isDeleted}}Not send {{Questionnaire|type}} because it has been removed{{/Questionnaire|isDeleted}}
        {{^Questionnaire|isDeleted}}
        Send {{Questionnaire|type}} {{Questionnaire|name}} {{^Questionnaire|approved}}(Note {{Questionnaire|type}} has not been approved){{/Questionnaire|approved}}
        {{/Questionnaire|isDeleted}}
        
        `.replace(/\t|\n\s*|\r|\t/g, ""),
        extra: ['Questionnaire']
    },
    "Send a notification": {
        icon: <Bell size={30} />,
        readableText: `
        {{#NOTIFICATION_DETAILS|recipient}}
            Send notification to {{.}}
        {{/NOTIFICATION_DETAILS|recipient}}
        {{^NOTIFICATION_DETAILS|recipient}}
            Not send notification because there are no recipients set
        {{/NOTIFICATION_DETAILS|recipient}}
        `.replace(/\t|\n\s*|\r|\t/g, ""),
        extra: ['NOTIFICATION_DETAILS']
    },
    /*
    {
  "ADD_CALENDAR_DETAILS|recipient": "All Clinicians in Facility",
  "ADD_CALENDAR_DETAILS|summary": "Tee",
  "ADD_CALENDAR_DETAILS|status": "CONFIRMED",
  "ADD_CALENDAR_DETAILS|CreateForWhen": "Following day of week",
  "ADD_CALENDAR_DETAILS|CreateForWhenDOW": "Mon",
  "ADD_CALENDAR_DETAILS|CreateForWhenTime": "Specific time",
  "ADD_CALENDAR_DETAILS|CreateForWhenTimeHH": "13",
  "ADD_CALENDAR_DETAILS|CreateForWhenTimeMM": "30"
}*/
    "Create a new calendar event": {
        icon: <CalendarPlus size={30} />,
        readableText: `
        {{#ADD_CALENDAR_DETAILS|CreateForWhenTime}}
            {{#ADD_CALENDAR_DETAILS|recipient}}
            Create a new calendar event for {{.}}
            {{#ADD_CALENDAR_DETAILS|CreateForWhen}} for the {{.}} {{ADD_CALENDAR_DETAILS|CreateForWhenDOW}} {{/ADD_CALENDAR_DETAILS|CreateForWhen}}
            at {{ADD_CALENDAR_DETAILS|CreateForWhenTime}}
            {{#ADD_CALENDAR_DETAILS|CreateForWhenTimeMM}} 
            {{ADD_CALENDAR_DETAILS|CreateForWhenTimeHH}}:{{ADD_CALENDAR_DETAILS|CreateForWhenTimeMM}}
            {{/ADD_CALENDAR_DETAILS|CreateForWhenTimeMM}} 
            {{#ADD_CALENDAR_DETAILS|status}} setting status to {{.}}{{/ADD_CALENDAR_DETAILS|status}}
            {{#ADD_CALENDAR_DETAILS|summary}} with summary {{.}}{{/ADD_CALENDAR_DETAILS|summary}}
            {{/ADD_CALENDAR_DETAILS|recipient}}
            {{^ADD_CALENDAR_DETAILS|recipient}}
            Will not create a calendar event because there are no recipients specified
            {{/ADD_CALENDAR_DETAILS|recipient}}
        {{/ADD_CALENDAR_DETAILS|CreateForWhenTime}}
        {{^ADD_CALENDAR_DETAILS|CreateForWhenTime}}
        Will not create a calendar event because there has been no time slot specified
        {{/ADD_CALENDAR_DETAILS|CreateForWhenTime}}
         
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    "Update a calendar event": {
        icon: <Calendar2 size={30} />,
        readableText: 'Update a new calendar event',
    },
    "Set the status of a To Do list item": {
        icon: <Check2Circle size={30} />,
        readableText: 'Set the status of a To Do list item',
    },
    "Allocate To Do list item": {
        icon: <Check2Circle size={30} />,
        readableText: 'Allocate To Do list item',
    },
    /*{
  "LOG_PATIENT_HISTORY|category": "Payments",
  "LOG_PATIENT_HISTORY|event": "Patient payment confirmation"
}*/
    "Log to patient history": {
        icon: <PersonAdd size={30} />,
        readableText: `
        {{#LOG_PATIENT_HISTORY|event}}
        Log event {{.}} to the patients history 
        {{#LOG_PATIENT_HISTORY|category}}
        under the {{.}} category 
        {{/LOG_PATIENT_HISTORY|category}}
        {{^LOG_PATIENT_HISTORY|category}}
        under the unknown category
        {{/LOG_PATIENT_HISTORY|category}}
        {{/LOG_PATIENT_HISTORY|event}}
        {{^LOG_PATIENT_HISTORY|event}}
        Not log an entry to the patients history because of in sufficient logging information
        {{/LOG_PATIENT_HISTORY|event}}
        `.replace(/\t|\n\s*|\r|\t/g, ""),
    },
    "Generate A Form": {
        icon: <Clipboard2Plus size={30} />,
        readableText: `
        {{#Form|isDeleted}}Not send {{Form|type}} because it has been removed{{/Form|isDeleted}}
        {{^Form|isDeleted}}
        Send {{Form|type}} {{Form|name}} {{^Form|approved}}(Note {{Form|type}} has not been approved){{/Form|approved}}
        {{/Form|isDeleted}}
        `.replace(/\t|\n\s*|\r|\t/g, ""),
        extra: ['Form']
    },
    "Allocate a To Do list": {
        icon: <Check2Circle size={30} />,
        readableText: 'Allocate a To Do list',
    }

}

const WFTriggerEventsBD = ({ trigger }) => {
    const [extras, setExtra] = useState({})
    const [vars, setVars] = useState()
    const [text, setText] = useState()

    const LOCKED_KEYS = ['questionnaire_started|isLocked']
    const DELETED_KEYS = ['questionnaire_started|isDeleted']

    useEffect(() => {
        const GetExtraDetails = async (extras, props) => {
            var res = {}
            for (const e of extras) {
                switch (e) {
                    case 'Message Template':
                        const template = await MessageTemple.GetMessageTemplates(props['Message Template'])
                            .catch(err => console.error('Message Template', err))
                        res = { ...res, ...TheLoop(template, 'Message Template') }
                        setExtra({ ...extras, 'Message Template': template })
                        break;
                    case 'Questionnaire':
                        const questionnaire = await Questionnaire.GetQuestionnaire(props['Questionnaire'])
                            .catch(err => console.error('Questionnaire', err))
                        res = { ...res, ...TheLoop(questionnaire, 'Questionnaire') }
                        setExtra({ ...extras, 'Questionnaire': questionnaire })
                        break;
                    case 'Form':
                        const form = await Questionnaire.GetQuestionnaire(props['Form'])
                            .catch(err => console.error('Form', err))
                        res = { ...res, ...TheLoop(form, 'Form') }
                        setExtra({ ...extras, 'Form': form })
                        break;
                    case 'Calendar Created':
                        const calendar = await Calendars.GetCalendarEventById(props['calendar_created|calendars|id'])
                            .catch(err => console.error('Calendar', err))
                        // console.log('Calendar RES ', calendar)
                        // res = { ...res, ...TheLoop(calendar, 'Calendar') }
                        setExtra({ ...extras, 'Calendar': calendar })
                        break;
                    default: console.log('type', e); break;
                }
            }
            return res
        }
        const Extract = async () => {
            var res = {}
            for (const prop of trigger.properties) {
                res = { ...res, ...TheLoop(typeof prop.value === 'string' ? JSON.parse(prop.value) : prop.value, prop.property) }
                // console.log('must ', prop.property, typeof prop.value === 'string' ? JSON.parse(prop.value) : prop.value)
            }
            try {
                if (Object.keys(TRIGGER_CONFIG[trigger.type.key]).includes('extra')) {
                    res = { ...res, ...await GetExtraDetails(TRIGGER_CONFIG[trigger.type.key].extra, res) }
                }
            } catch (e) {
                // console.log('must res unknown key ', e, JSON.stringify(trigger.type.key))
            }
            // console.log('must res ', res)

            setVars({ ...res })
        }
        const TheLoop = (props, parent) => {
            var res = {}

            if (Array.isArray(props)) {
                for (const o of props) {
                    res = { ...res, ...TheLoop(o, parent) }
                }
            }
            else if (typeof props === 'object')
                for (const o of Object.keys(props)) {
                    if (o === 'receivedFrom') {
                        if (Array.isArray(props[o]) && isNaN(Object.keys(props[o][0]))) {
                            res = {
                                ...res,
                                ...{ [parent + '|receivedFrom']: props[o].join(',') }
                            }
                        } else {
                            res = {
                                ...res,
                                ...{ [parent + '|receivedFrom']: Object.keys(props[o]).join(',') }
                            }
                        }
                    } else
                        res = { ...res, ...TheLoop(props[o], parent + '|' + o) }
                }
            else {
                res[parent] = props
            }
            return res;
        }
        if (Object.keys(TRIGGER_CONFIG).includes(trigger.type.key))
            Extract()
    }, [])

    useEffect(() => {
        if (vars && TRIGGER_CONFIG[trigger.type.key] && TRIGGER_CONFIG[trigger.type.key].readableText) {
            setText(Mustache.render(TRIGGER_CONFIG[trigger.type.key].readableText, vars))
        }
    }, [vars])


    const isLocked = () => {
        for (const k of Object.keys(vars))
            if (LOCKED_KEYS.includes(k) && vars[k])
                return true
        return false
    }
    const isDeleted = () => {
        for (const k of Object.keys(vars))
            if (DELETED_KEYS.includes(k) && vars[k])
                return true
        return false
    }

    return (<div>{!Object.keys(TRIGGER_CONFIG).includes(trigger.type.key) ? `Unsupported trigger type ${trigger.type.key}` :
        <>
            {
                vars &&
                <>
                    {/* <pre>
                        {JSON.stringify(trigger.properties, '\t', 2)}
                        {JSON.stringify(vars, '\t', 2)}
                    </pre> */}
                    {isLocked() && <LockFill />}
                    {isDeleted() && <Trash2 />}
                    {TRIGGER_CONFIG[trigger.type.key].icon && TRIGGER_CONFIG[trigger.type.key].icon}
                    {text && text}
                </>
            }
        </>
    } </div>)
}

const WFTaskBD = ({ task }) => {
    const [extras, setExtra] = useState({})
    const [vars, setVars] = useState()
    const [text, setText] = useState()

    const LOCKED_KEYS = ['questionnaire_started|isLocked']
    const DELETED_KEYS = ['questionnaire_started|isDeleted']

    useEffect(() => {
        const GetExtraDetails = async (extras, props) => {
            var res = {}
            for (const e of extras) {
                switch (e) {
                    case 'Message Template':
                        const template = await MessageTemple.GetMessageTemplates(props['Message Template'])
                            .catch(err => console.error('Message Template', err))
                        res = { ...res, ...TheLoop(template, 'Message Template') }
                        setExtra({ ...extras, 'Message Template': template })
                        break;
                    case 'Questionnaire':
                        const questionnaire = await Questionnaire.GetQuestionnaire(props['Questionnaire'])
                            .catch(err => console.error('Questionnaire', err))
                        res = { ...res, ...TheLoop(questionnaire, 'Questionnaire') }
                        setExtra({ ...extras, 'Questionnaire': questionnaire })
                        break;
                    case 'Form':
                        const form = await Questionnaire.GetQuestionnaire(props['Form'])
                            .catch(err => console.error('Form', err))
                        res = { ...res, ...TheLoop(form, 'Form') }
                        setExtra({ ...extras, 'Form': form })
                        break;
                    default: console.log('type', e); break;
                }
            }
            return res
        }
        const Extract = async () => {
            var res = {}
            for (const prop of task.properties) {
                res = { ...res, ...TheLoop(typeof prop.value === 'string' ? JSON.parse(prop.value) : prop.value, prop.type.type) }
                // console.log('must ', prop.property, typeof prop.value === 'string' ? JSON.parse(prop.value) : prop.value)
            }
            if (Object.keys(TASK_CONFIG[task.taskType.type]).includes('extra')) {
                res = { ...res, ...await GetExtraDetails(TASK_CONFIG[task.taskType.type].extra, res) }
            }
            setVars({ ...res })
        }
        const TheLoop = (props, parent) => {
            var res = {}

            if (Array.isArray(props)) {
                for (const o of props) {
                    res = { ...res, ...TheLoop(o, parent) }
                }
            }
            else if (typeof props === 'object')
                for (const o of Object.keys(props)) {
                    if (o === 'receivedFrom') {
                        res = {
                            ...res,
                            ...{ [parent + '|receivedFrom']: Object.keys(props[o]) }
                        }
                    } else
                        res = { ...res, ...TheLoop(props[o], parent + '|' + o) }
                }
            else {
                res[parent] = props
            }
            return res;
        }
        if (Object.keys(TASK_CONFIG).includes(task.taskType.type))
            Extract()
    }, [])

    useEffect(() => {
        if (vars && TASK_CONFIG[task.taskType.type] && TASK_CONFIG[task.taskType.type].readableText) {
            setText(Mustache.render(TASK_CONFIG[task.taskType.type].readableText, vars))
        }
    }, [vars])


    const isLocked = () => {
        for (const k of Object.keys(vars))
            if (LOCKED_KEYS.includes(k) && vars[k])
                return true
        return false
    }
    const isDeleted = () => {
        for (const k of Object.keys(vars))
            if (DELETED_KEYS.includes(k) && vars[k])
                return true
        return false
    }
    // <div>
    return (<div>
        {!Object.keys(TASK_CONFIG).includes(task.taskType.type) ? `Unsupported task type ${task.taskType.type}` :
            <>
                {
                    vars &&
                    <>
                        {/* <pre>
                            {JSON.stringify(task.properties, '\t', 2)}
                            {JSON.stringify(vars, '\t', 2)}
                        </pre> */}
                        {isLocked() && <LockFill />}
                        {isDeleted() && <Trash2 />}
                        {TASK_CONFIG[task.taskType.type].icon && TASK_CONFIG[task.taskType.type].icon}
                        {text && text}
                        {
                            TASK_CONFIG[task.taskType.type].extra &&
                            TASK_CONFIG[task.taskType.type].extra.map(ex => {
                                return ({
                                    'Message Template': <ShowHideExtras title='Message Template' >
                                        <MessageTemplatePreview Cached={extras['Message Template']} />
                                    </ShowHideExtras>,
                                    'Questionnaire': <ShowHideExtras title='Questionnaire' >
                                        <FormPreview Cached={extras['Questionnaire']} />
                                    </ShowHideExtras>,
                                    'Form': <ShowHideExtras title='Form' >
                                        <FormPreview Cached={extras['Form']} />
                                    </ShowHideExtras>,
                                    'NOTIFICATION_DETAILS': <ShowHideExtras title='Notification' >
                                        <NotificationPreview Details={{
                                            recipient: vars['NOTIFICATION_DETAILS|recipient'],
                                            html: vars['NOTIFICATION_DETAILS|Notification|html'],
                                        }} />
                                    </ShowHideExtras>,
                                }[ex])
                            })
                        }
                    </>
                }
            </>
        } </div>)
}

const ShowHideExtras = ({ title, children }) => {
    const [open, isOpen] = useState(false)
    return (<div className='ms-2 collapsable' onClick={e => isOpen(!open)}>
        <div className='text-secondary'>{` - ${open ? 'Hide' : 'Show'} ${title}`}</div>
        <div className={`${open ? 'slide-down' : 'slide-up'}`}>{children}</div>
    </div>)
}
// const ReplaceVars = (text, properties, requires) => {
//     const FindProp = (prop) => {
//         if (!properties) return undefined
//         if (typeof properties.find(x => x.property === prop) === 'undefined') return undefined
//         return typeof properties.find(x => x.property === prop).value === 'string' ? JSON.parse(properties.find(x => x.property === prop).value)
//             : properties.find(x => x.property === prop).value
//     }
//     const FindValue = (TagVal) => {
//         var StrSpl = TagVal.split('.')
//         const property = FindProp(StrSpl[0])
//         if (!property) return undefined
//         if (Array.isArray(property)) {
//             return !Object.keys(property[0]).includes(StrSpl[1]) ? 'Unknown' : property.map(x => x[StrSpl[1]]).join(',')
//         }
//         return !Object.keys(property).includes(StrSpl[1]) ? undefined : property[StrSpl[1]]
//     }
//     // console.log('ReplaceVars', text)
//     var _text = text
//     const myRegexp = new RegExp(/{{\s*[\w\.]+\s*}}/, 'g'); // new RegExp("", "gm");
//     for (const tag of text.match(myRegexp) ?? []) {
//         var TagVal = tag.substring(2, tag.length - 2)
//         const value = FindValue(TagVal)
//         if (!value && requires && Object.keys(requires).includes(TagVal))
//             return requires[TagVal]
//         else
//             _text = _text.replaceAll(tag, value)
//     }
//     return _text;
// }